import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { autoUpdate, offset, flip, shift, arrow } from '@floating-ui/react-dom';
import { useFloating, useHover, useFocus, useRole, useInteractions } from '@floating-ui/react-dom-interactions';
import React, { useState, useRef, useMemo } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { TOOLTIP_BACKGROUND_COLOR_VAR, TOOLTIP_BORDER_RADIUS_VAR, TOOLTIP_COLOR_VAR } from './Tooltip.consts.esm.js';
import { Side, getOppositeSide } from './tooltip.helpers.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background-color: var(",
        ", ",
        ");\n    border-radius: var(",
        ", ",
        "px);\n    color: var(",
        ", ",
        ");\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: max-content;\n  z-index: 1;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    background-color: var(",
        ", ",
        ");\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  position: absolute;\n  transform: rotate(45deg);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var TooltipContainer = styled.div(_templateObject1(), function(param) {
    var colors = param.colors, _param_tooltip = param.tooltip, borderRadius = _param_tooltip.borderRadius, tooltipStyling = _param_tooltip.tooltipStyling, backgroundColor = _param_tooltip.backgroundColorName, color = _param_tooltip.colorName;
    return css(_templateObject(), TOOLTIP_BACKGROUND_COLOR_VAR, colors[backgroundColor], TOOLTIP_BORDER_RADIUS_VAR, borderRadius, TOOLTIP_COLOR_VAR, colors[color], tooltipStyling);
});
var Arrow = styled.div(_templateObject3(), function(param) {
    var colors = param.colors, _param_tooltip = param.tooltip, backgroundColor = _param_tooltip.backgroundColorName;
    return css(_templateObject2(), TOOLTIP_BACKGROUND_COLOR_VAR, colors[backgroundColor]);
});
var ExtendedTooltip = function(_param) {
    var children = _param.children, content = _param.content, _param_tooltipShiftPadding = _param.tooltipShiftPadding, tooltipShiftPadding = _param_tooltipShiftPadding === void 0 ? 0 : _param_tooltipShiftPadding, tooltipArrowSize = _param.tooltipArrowSize, tooltipMargin = _param.tooltipMargin, _param_placement = _param.placement, placement = _param_placement === void 0 ? Side.Bottom : _param_placement, props = _object_without_properties(_param, [
        "children",
        "content",
        "tooltipShiftPadding",
        "tooltipArrowSize",
        "tooltipMargin",
        "placement"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var arrowRef = useRef(null);
    var _useTheme = useTheme(), colors = _useTheme.colors, tooltip = _useTheme.tooltip;
    var _tooltip_margin = tooltip.margin, margin = _tooltip_margin === void 0 ? 0 : _tooltip_margin, _tooltip_triangleSize = tooltip.triangleSize, triangleSize = _tooltip_triangleSize === void 0 ? 0 : _tooltip_triangleSize;
    var offsetValue = tooltipMargin !== null && tooltipMargin !== void 0 ? tooltipMargin : margin;
    var _useFloating = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(offsetValue),
            flip(),
            shift({
                padding: tooltipShiftPadding
            }),
            arrow({
                element: arrowRef
            })
        ],
        placement: placement
    }), context = _useFloating.context, x = _useFloating.x, y = _useFloating.y, reference = _useFloating.reference, floating = _useFloating.floating, floatingPlacement = _useFloating.placement, strategy = _useFloating.strategy, _useFloating_middlewareData = _useFloating.middlewareData, tmp = _useFloating_middlewareData.arrow, _ref = tmp === void 0 ? {} : tmp, arrowX = _ref.x, arrowY = _ref.y;
    var hover = useHover(context, props.hoverOptions);
    var focus = useFocus(context);
    var role = useRole(context);
    var _useInteractions = useInteractions([
        hover,
        focus,
        role
    ]), getFloatingProps = _useInteractions.getFloatingProps, getReferenceProps = _useInteractions.getReferenceProps;
    var tooltipReferenceElement = /*#__PURE__*/ React.cloneElement(children, getReferenceProps(_object_spread({
        ref: reference
    }, children.props)));
    var oppositeSide = useMemo(function() {
        return getOppositeSide(floatingPlacement.split("-")[0]);
    }, [
        floatingPlacement
    ]);
    var size = useMemo(function() {
        return tooltipArrowSize !== null && tooltipArrowSize !== void 0 ? tooltipArrowSize : triangleSize;
    }, [
        triangleSize,
        tooltipArrowSize
    ]);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            tooltipReferenceElement,
            isOpen && /*#__PURE__*/ jsxs(TooltipContainer, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                colors: colors,
                ref: floating,
                tooltip: tooltip
            }, props), {
                style: _object_spread({
                    left: "".concat(x !== null && x !== void 0 ? x : 0, "px"),
                    position: strategy,
                    top: "".concat(y !== null && y !== void 0 ? y : 0, "px")
                }, props.style)
            }), getFloatingProps()), {
                children: [
                    content,
                    /*#__PURE__*/ jsx(Arrow, {
                        colors: colors,
                        ref: arrowRef,
                        style: _define_property({
                            height: "".concat(size, "px"),
                            width: "".concat(size, "px"),
                            left: "".concat(arrowX != null ? "".concat(arrowX, "px") : ""),
                            top: "".concat(arrowY != null ? "".concat(arrowY, "px") : "")
                        }, oppositeSide, "-".concat(size / 2, "px")),
                        tooltip: tooltip
                    })
                ]
            }))
        ]
    });
};

export { ExtendedTooltip };
